module.exports = __webpack_public_path__ + "static/media/touche logo.e4fd474c.png";